<template>
    <div
        v-if="visible > 0"
        class="progressbar"
    >
        <div class="progressbar__circle"/>
    </div>
</template>

<script>

import {EventBus} from '@/utils/eventBus';

export default {

    data() {
        return {
            visible: 0
        };
    },

    mounted() {
        EventBus.on('progressbar:on', () => {
            this.visible++;
        });
        EventBus.on('progressbar:off', () => {
            this.visible--;
        });
    }

};
</script>

<style lang="scss">
    @keyframes rotator {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
    .progressbar {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        z-index: 100;
        background: rgba(239, 224, 244, 0.8);
        &__circle {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translateX(-50%) translateY(-50%);
            box-sizing: border-box;
            animation-name: rotator;
            animation-duration: 1.3s;
            animation-iteration-count: infinite;
            animation-timing-function: cubic-bezier(0.53, 0.21, 0.29, 0.67);
            width: 50px;
            height: 50px;
            border-radius: 50%;
            border-width: 3px;
            border-style: solid;
            border-color: rgb(0, 120, 212) rgb(199, 224, 244) rgb(199, 224, 244);
            border-image: initial;
        }
    }
</style>
